import React from 'react';
import PropType from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './HeatmapBackToResultsButton.scss';

export default function HeatmapBackToResultsButton({ toContextLabel, showResultsList }) {
  return (
    <ButtonWithIcon
      type="tertiary"
      size="small"
      linkIconSize="s"
      sprite="Rows"
      tabIndex="0"
      onClick={() => {
        showResultsList();
      }}
      className="result-toolbar-heatmap-back-to-results-button e2e-heatmap-back-to-results"
      aria-label={`Back to ${toContextLabel} list`}>
      {toContextLabel}
    </ButtonWithIcon>
  );
}

HeatmapBackToResultsButton.propType = {
  toContextLabel: PropType.string.isRequired,
  showResultsList: PropType.func.isRequired,
};
